module.exports = "<div class=q-marg-all-xl> <div class=discrepancies-reslved-alert-body> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/receivingDiscrepancies/html/resolvedDiscrepanciesModalBody.html
// module id = 1394
// module chunks = 1